<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-08-05 11:41:37
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-09-30 14:50:08
 *
 message 对象定义
 {
  id: String,           // createId('message')
  data: Object || null, // { name: '张三' }
  act: String || null,  // 'closeDialog', 'freshList'
 }
 *
-->
<template>
  <el-dialog
    v-if="visible"
    :title="title"
    :visible.sync="visible"
    :fullscreen="option.fullscreen==='是'"
    :width="option.width"
    append-to-body
  >
    <div
      class="dialog-container"
      :style="styleSize"
    >
      <iframe
        :src="src"
        class="dialog-iframe"
        ref="dialogIframe"
        @load="loaded"
      ></iframe>
    </div>
    <!-- <span slot="footer">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-circle-check"
        @click="onSubmit"
      >{{data.confirm}}</el-button>
      <el-button
        size="small"
        @click="visible = false"
        icon="el-icon-circle-close"
      >{{data.cancel}}</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { isEmpty, getTextByAnalysis } from '@/dragComponents/utils'

export default {
  name: 'report-dialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    change: {
      type: Function
    }
  },
  data() {
    return {
      visible: false,
      src: ''
    }
  },
  computed: {
    styleSize() {
      return {
        width: '100%',
        height: this.option.height || '300px'
      }
    }
  },
  watch: {
    show(val) {
      this.src = getTextByAnalysis(this.option.url, this.data?.row)
      this.visible = val
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  methods: {
    loaded() {
      // console.log(104, this.option.url)
      // this.$refs.dialogIframe.contentWindow.postMessage(
      //   {
      //     id: createId('message'),
      //     data: { name: '张三' },
      //     act: null
      //   },
      //   '*'
      // )
    },
    onSubmit() {
      this.visible = false
    }
  },
  mounted() {
    window.addEventListener(
      'message',
      (evt) => {
        let data = evt.data
        if (isEmpty(data)) return
        switch (data.act) {
          case 'closeDialog':
            this.visible = false
            break
          case 'freshList':
            this.visible = false
            this.$emit('change', data.act)
            break
        }
      },
      false
    )
  }
}
</script>
<style lang="scss" soped>
.dialog {
  &-container {
    width: 100%;
    height: 100%;
  }

  &-iframe {
    width: 100%;
    height: 100%;
    border: 0;
    overflow: hidden;
    box-sizing: border-box;
  }
}
</style>
